import { Container, Grid } from '@mui/material';
import { HomeCompareImage } from './HomeCompareImage';
import {HomeSection01} from "./HomeSection01";
import {HomeSection02} from "./HomeSection02";
import {HomeSection03} from "./HomeSection03";
import bgImage from 'shared/assets/img/bg01.jpg'

import './home-page.scss';

export const HomeView = () => {
  return (
    <Container
      sx={{
        height: '100%',
        marginInline: 'auto',
    }}
      className="home-view"
    >
      <div className='bg-image' style={{backgroundImage: `url(${bgImage})`}}></div>
      <Grid
        container
        sx = {{
          display: 'flex',
          justifyContent: {lg: 'space-between', xs: 'center'},
          marginBottom: {lg: '30px', xs: '20px'},
          flexDirection: {lg: 'row', xs:'column'}
        }}
      >
        <Grid
          item
          sx = {{
            order: {lg:'1', xs:'2'}
          }}
          className="home-left"
        >
          <HomeSection01 />
          <HomeSection03 />
          <HomeSection02 /> 
        </Grid>
        <Grid
          item
          sx = {{
            order: {lg:'2', xs:'1'},
            display: 'flex',
            justifyContent: {xs:'center'}
          }}
          className="home-right"
        >
          <HomeCompareImage />
        </Grid>
      </Grid>
    </Container>
  );
};
